module.exports = __webpack_public_path__ + "static/img/56.4c31c42.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/56.gif
// module id = UFvv
// module chunks = 0